import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { CheckoutProvider, useCheckout } from '../../contexts/CheckoutContext';
import CheckoutStepper from '../../components/checkout/CheckoutStepper';
import LocationStep from '../../components/checkout/LocationStep';
import PaymentOptionsStep from '../../components/checkout/PaymentOptionsStep';
import BankTransferStep from '../../components/checkout/BankTransferStep';
import ETransferStep from '../../components/checkout/ETransferStep';
import ConfirmationStep from '../../components/checkout/ConfirmationStep';

/**
 * CheckoutContent Component
 * Renders the appropriate step based on currentStep in context
 */
const CheckoutContent = () => {
  const { currentStep, paymentMethod } = useCheckout();

  // Render the appropriate step based on the current step and payment method
  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <LocationStep />;
      case 1:
        return <PaymentOptionsStep />;
      case 2:
        // Show bank transfer or e-transfer step based on payment method
        if (paymentMethod === 'interac') {
          return <ETransferStep />;
        } else {
          return <BankTransferStep />;
        }
      case 3:
        return <ConfirmationStep />;
      default:
        return <LocationStep />;
    }
  };

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Thailand Real Estate Diligence Trip - Checkout
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Powered by <strong>Creatos Inc.</strong> | Fulfilled by <strong>Own Thailand Now</strong>
          </Typography>
        </Box>

        <CheckoutStepper />
        
        {renderStep()}
      </Container>
    </Box>
  );
};

/**
 * Checkout Page Component
 * Wraps the checkout content with the CheckoutProvider
 */
const Checkout = () => {
  return (
    <CheckoutProvider>
      <CheckoutContent />
    </CheckoutProvider>
  );
};

export default Checkout;